module.exports = __webpack_public_path__ + "static/fingerprint-cb4455f671d56365b1eaa624aafc0524.png";